<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!hasData" class="dw-empty">No alerts in this period.</div>
    <template v-else>
      <div class="dw-stat-grid">
        <div class="dw-stat-tile">
          <div class="dw-stat-tile-label">Email Success</div>
          <div class="dw-stat-tile-value text-success">{{ counts['Email Success'] }}</div>
        </div>
        <div class="dw-stat-tile">
          <div class="dw-stat-tile-label">Email Fail</div>
          <div class="dw-stat-tile-value" :class="counts['Email Fail'] > 0 ? 'text-danger' : ''">{{ counts['Email Fail'] }}</div>
        </div>
        <div class="dw-stat-tile">
          <div class="dw-stat-tile-label">SMS Success</div>
          <div class="dw-stat-tile-value text-success">{{ counts['SMS Success'] }}</div>
        </div>
        <div class="dw-stat-tile">
          <div class="dw-stat-tile-label">SMS Fail</div>
          <div class="dw-stat-tile-value" :class="counts['SMS Fail'] > 0 ? 'text-danger' : ''">{{ counts['SMS Fail'] }}</div>
        </div>
      </div>
      <div v-if="truncated" class="dw-truncation-note">
        Counts reflect the {{ resultsLimit.toLocaleString() }} most recent alerts in this range.
      </div>
    </template>
  </div>
</template>

<script>
import { deliveryOutcomeCounts } from '../../utils/alerts_analytics'

export default {
  name: 'widget_delivery_status',
  props: {
    // shared across every alert-detail widget by main_dashboard.vue's
    // load_alerts_detail(), so this widget costs no API call of its own.
    alerts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    // true when the API capped the shared alert fetch at its newest-first
    // results_limit -- counts then only cover that slice.
    truncated: { type: Boolean, default: false },
    resultsLimit: { type: Number, default: 0 },
  },
  computed: {
    counts() {
      return deliveryOutcomeCounts(this.alerts)
    },
    hasData() {
      return Object.values(this.counts).some(v => v > 0)
    },
  },
}
</script>
